import { toValidNumber } from '@ztechapps/common.utils'

export type TopUpFormValues = { credits: number; reason: string }

/**
 * Formik validator for the AI credits top-up form: the amount must be greater than 0, and a blank or non-numeric value
 * counts as 0. The reason is free text and never validated; returns `{}` when valid.
 */
export const validateTopUp = (values: TopUpFormValues): Record<string, string> => {
  const errors: Record<string, string> = {}
  if (toValidNumber(values.credits) <= 0) errors.credits = 'Amount must be greater than 0'
  return errors
}
